import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnBG: CultureInfo = {
  name: 'en-BG',
  displayName: 'English (Bulgaria)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-BG',
  parent: CultureInfoEn
};
